import {
    STUDENTS_BY_GROUP_RETRIEVED,
    RESET_STUDENTS_BY_GROUP
} from './students-by-group-actions';

const initialState = {
    id: null,
    groups: []
};

/**
 * Students by Group Reducer
 *
 * Consumes STUDENTS_BY_GROUP_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - all groups with their respective students
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case STUDENTS_BY_GROUP_RETRIEVED:
            return action.payload;

        case RESET_STUDENTS_BY_GROUP:
            return { ...initialState };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/students-by-group/students-by-group-reducer.js